import { Component, Inject, OnInit } from '@angular/core';
import { take, finalize } from 'rxjs';
import { UserService } from '../../services/user/user.service';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-termo-aceite',
  templateUrl: './termo-aceite.component.html',
  styleUrls: ['./termo-aceite.component.scss']
})
export class TermoAceiteComponent implements OnInit {
  term:string;
  constructor(
    private userService: UserService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.term = data.termo;
   }

  ngOnInit() {
  }

  
}
